<template>
    <!-- eslint-disable vue/max-len -->
    <dtg-layout-about title="A propos de...">
        <dtg-card>
            <dtg-card-title>
                MyDTG (version actuelle&nbsp;: {{ version }})
            </dtg-card-title>

            <p>
                MyDTG, c’est une app web & mobile qui vous permet de gagner en efficacité
                sur vos prestations de Diagnostic Technique Global et diversifiez votre activité!
            </p>
            <p>
                Le DTG est une prestation qui demande au diagnostiqueur immobilier
                du temps et s'avère souvent très chronophage, une fois l'intervention
                sur site passée&nbsp;: reprise des éléments notés sur site, tri et attribution
                des photos, construction et remplissage du rapport sous Word… Le professionnel
                a de quoi s’y perdre, en plus des autres missions qui lui incombe.
            </p>
            <p>
                Avec MyDTG, bénéficiez d'un véritable assistant digital qui vous permet
                de gagner en productivité et de vous concentrer sur des missions à forte valeur ajoutée!
            </p>
            <p>
                Grâce à MyDTG, vous avez la possibilité de préparer votre rendez-vous en amont en le documentant.
                Sur site, vous renseignez directement dans l'app les pathologies observées et y intégrez les
                photos prises sur place de façon simple. De retour au bureau, il suffit simplement de finaliser
                les différentes informations récoltées puis de cliquer sur "Générer le DTG"&nbsp;: un rapport complet
                et conforme à la législation en vigueur est alors édité en PDF, aux couleurs du prestataire,
                directement partageable au commanditaire.
            </p>
        </dtg-card>
    </dtg-layout-about>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

import { DtgCard, DtgCardTitle } from 'dtg-components';

import { DtgLayoutAbout } from '@/components/layouts/layout-about';

import { ENV } from '@/utils/env';

export default defineComponent({
    name: 'dtg-page-about',

    components: {
        DtgCard,
        DtgCardTitle,
        DtgLayoutAbout,
    },

    setup() {
        const version = computed(() => ENV.VUE_APP_VERSION);

        return { version };
    },
});
</script>
